import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover, Tooltip } from '@mui/material';

import isEmpty from 'Lib/utilities/isEmpty';

export default function Options({ options = [] }) {
    const history = useHistory();
    const [anchorElement, setAnchorElement] = useState(null);

    const openPopover = Boolean(anchorElement);
    const id = openPopover ? 'table-options' : undefined;

    const handleClick = option => {
        if (option.to) {
            history.push(option.to);
        } else if (option.onClick) {
            option.onClick();
        }

        setAnchorElement(null);
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    return isEmpty(options) ? null : (
        <>
            <Tooltip title="Options" arrow placement="bottom">
                <Box>
                    <IconButton variant="regular" onClick={event => setAnchorElement(event.currentTarget)} sx={{ ml: 4 }}>
                        more_vert
                    </IconButton>
                </Box>
            </Tooltip>
            <Popover
                id={id}
                data-testid="saved-searches-popover"
                open={openPopover}
                anchorEl={anchorElement}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <List>
                    {options.map((option, index) => (
                        <ListItem key={index} onClick={() => handleClick(option)} disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    <span className="material-symbols-rounded">{option.icon}</span>
                                </ListItemIcon>
                                <ListItemText sx={{ ml: 2 }}>{option.label}</ListItemText>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </>
    );
}
